import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import analyticsService$1 from '@picsart/rc/services/analytics';
import IS_BROWSER from '@picsart/rc/isBrowser';
import { getGclidValue, getClientId } from '../googleClickIdService/index.js';
import { getImpactClickId } from '../impactService/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var checkoutAnalyticsParams = ['page_origin', 'action_button'];
var getScreenType = function getScreenType(view) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    isPricingView = _ref.isPricingView,
    isCreditsTabView = _ref.isCreditsTabView,
    isCreditsView = _ref.isCreditsView;
  var viewsMap = {
    form: 'card_info',
    plans: 'package_info',
    tiers: isPricingView ? 'pricing_page' : 'tier_info',
    team: 'seat_info',
    packages: isCreditsTabView ? 'credits_package_info' : isCreditsView ? 'credits_info' : 'gen_package_info'
  };
  return viewsMap[view];
};
var subscriptionStatusMap = {
  SUBSCRIPTION_ON_HOLD: 'on_hold',
  SUBSCRIPTION_IN_GRACE_PERIOD: 'grace',
  SUBSCRIPTION_CANCELED: 'cancelled'
};
var getLastRenewalPaymentStatus = function getLastRenewalPaymentStatus(paymentStatus, prevTier) {
  return paymentStatus === 'FREE_TRIAL' ? 'free_trial' : prevTier === 'free' ? 'free' : 'paid';
};
var getUserSubscriptionCurrentInfo = function getUserSubscriptionCurrentInfo(userOrder) {
  var _userOrder$additional, _userOrder$tier, _userOrder$maxOrder$s, _userOrder$maxOrder, _userOrder$maxOrder2;
  return {
    current_status: getLastRenewalPaymentStatus(userOrder === null || userOrder === void 0 || (_userOrder$additional = userOrder.additionalInfo) === null || _userOrder$additional === void 0 ? void 0 : _userOrder$additional.lastRenewalPaymentStatus, userOrder === null || userOrder === void 0 || (_userOrder$tier = userOrder.tier) === null || _userOrder$tier === void 0 ? void 0 : _userOrder$tier.id),
    current_state: subscriptionStatusMap[(_userOrder$maxOrder$s = userOrder === null || userOrder === void 0 || (_userOrder$maxOrder = userOrder.maxOrder) === null || _userOrder$maxOrder === void 0 ? void 0 : _userOrder$maxOrder.status) !== null && _userOrder$maxOrder$s !== void 0 ? _userOrder$maxOrder$s : ''] || null,
    current_subscription_id: (userOrder === null || userOrder === void 0 || (_userOrder$maxOrder2 = userOrder.maxOrder) === null || _userOrder$maxOrder2 === void 0 ? void 0 : _userOrder$maxOrder2.original_order_id) || null
  };
};
var getPackageId = function getPackageId() {
  var frequency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var packageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'free';
  var typesMap = {
    max_performance: '_max_performance',
    student: '_student_discount',
    max_starter: '_max_starter',
    enterprise: '_enterprise',
    gold_old: '_gold_old',
    teams: '_teams',
    plus: '_plus',
    pro: '_pro',
    free: ''
  };
  return "com.picsart.www.subscription_".concat(frequency).concat(typesMap[packageType]);
};
var getCheckoutAnalyticsParams = function getCheckoutAnalyticsParams() {
  if (!IS_BROWSER) {
    return {};
  }
  var params = new URLSearchParams(window.location.search);
  return checkoutAnalyticsParams.reduce(function (acc, val) {
    var paramValue = params.get(val);
    if (!paramValue) {
      return acc;
    }
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, val, paramValue));
  }, {});
};
var clearCheckoutAnalyticsParams = function clearCheckoutAnalyticsParams() {
  if (!IS_BROWSER) {
    return;
  }
  var newUrl = new URL(window.location.href);
  checkoutAnalyticsParams.forEach(function (param) {
    return newUrl.searchParams["delete"](param);
  });
  window.history.replaceState({}, '', newUrl.toString());
};
var sendExperimentEvent = function sendExperimentEvent(_ref2) {
  var variant = _ref2.variant,
    id = _ref2.id;
  analyticsService$1.sendEvent('ssr_experiment', {
    name: id,
    variant: variant
  });
};
var getAnalyticsInfo = function getAnalyticsInfo() {
  return {
    gclid_field: getGclidValue(),
    impact_click_id: getImpactClickId(),
    clientId: getClientId()
  };
};
var analyticsService = {
  clearCheckoutAnalyticsParams: clearCheckoutAnalyticsParams,
  getCheckoutAnalyticsParams: getCheckoutAnalyticsParams,
  sendExperimentEvent: sendExperimentEvent,
  getAnalyticsInfo: getAnalyticsInfo,
  getScreenType: getScreenType,
  getPackageId: getPackageId
};

export { clearCheckoutAnalyticsParams, analyticsService as default, getAnalyticsInfo, getCheckoutAnalyticsParams, getLastRenewalPaymentStatus, getPackageId, getScreenType, getUserSubscriptionCurrentInfo, sendExperimentEvent, subscriptionStatusMap };
//# sourceMappingURL=index.js.map
